import { render, staticRenderFns } from "./outcomeStockMovementPage.vue?vue&type=template&id=4667aaf4&"
import script from "./outcomeStockMovementPage.vue?vue&type=script&lang=ts&"
export * from "./outcomeStockMovementPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports